module.exports = __webpack_public_path__ + "img/elauwit.bd8319e8.png";